<template>
  <div class="alta-inventario">
    <div class="content">
      <h2>Alta de Inventario</h2>

      <div class="form-card floating-card">
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <div class="input-group align-columns">
              <div class="column">
                <label for="productName">Modelo del vestido:</label>
                <input type="text" id="productName" v-model="productName" required />
              </div>
              <div class="column image-preview-container">
                <label for="dressPhoto">
                  <div class="image-preview clickable-preview">
                    <img :src="previewImage || require('@/assets/placeholder.jpg')" alt="Vista previa" />
                  </div>
                </label>
                <input type="file" id="dressPhoto" @change="handleFileUpload" style="display: none" />
              </div>
            </div>

            <div class="input-group">
              <div>
                <label for="brand">Marca:</label>
                <select id="brand" v-model="brand" required>
                  <option value="La Divine">La Divine</option>
                  <option value="Passion Dress">Passion Dress</option>
                  <option value="Andrea y Leo">Andrea y Leo</option>
                  <option value="Rica Rica">Rica Rica</option>
                  <option value="Otros">Otros</option>
                </select>
              </div>
              <div>
                <label for="description">Descripción:</label>
                <input type="text" id="description" v-model="description" required />
              </div>
            </div>

            <div class="input-group">
              <div>
                <label for="color">Color:</label>
                <select id="color" v-model="color" required>
                  <option value="Negro">Negro</option>
                  <option value="Azul Marino">Azul Marino</option>
                  <option value="Azul Rey">Azul Rey</option>

                  <option value="Dorado">Dorado</option>
                  <option value="Plateado">Plateado</option>

                  <option value="Rojo">Rojo</option>
                  <option value="Fucsia">Fucsia</option>
                  <option value="Rosa Claro">Rosa Claro</option>
                  <option value="Celeste">Celeste</option>
                  <option value="Aqua">Aqua</option>
                  <option value="Guindo">Guindo</option>
                  <option value="Verde">Verde</option>
                  <option value="Verde Lima">Verde Lima</option>
                  <option value="Lila">Lila</option>
                  <option value="Morado">Morado</option>
                </select>
              </div>
              <div>
                <label for="size">Talla:</label>
                <select id="size" v-model="size" required>
                  <option value="XS">XS</option>
                  <option value="S">S</option>
                  <option value="M">M</option>
                  <option value="L">L</option>
                  <option value="XL">XL</option>
                  <option value="XXL">XXL</option>
                  <option value="XXXL">XXXL</option>
                </select>
              </div>
              <div>
                <label for="sizeNumber">Número de talla:</label>
                <select id="sizeNumber" v-model="sizeNumber" required>
                  <option value="2">2</option>
                  <option value="4">4</option>
                  <option value="6">6</option>
                  <option value="8">8</option>
                  <option value="10">10</option>
                  <option value="12">12</option>
                  <option value="14">14</option>
                  <option value="16">16</option>
                  <option value="18">18</option>
                  <option value="20">20</option>
                  <option value="20">22</option>

                </select>
              </div>
            </div>

            <div class="input-group">
              <div>
                <label for="purchaseCost">Costo de compra:</label>
                <input 
                  type="text" 
                  id="purchaseCost" 
                  v-model="purchaseCostDisplay" 
                  required
                  @focus="clearDefaultValue('purchaseCostDisplay')" 
                  @blur="restoreDefaultValue('purchaseCostDisplay')" 
                  @input="formatCurrency('purchaseCostDisplay')"
                />
              </div>
              <div>
                <label for="rentalCost">Costo de renta:</label>
                <input 
                  type="text" 
                  id="rentalCost" 
                  v-model="rentalCostDisplay" 
                  required
                  @focus="clearDefaultValue('rentalCostDisplay')" 
                  @blur="restoreDefaultValue('rentalCostDisplay')" 
                  @input="formatCurrency('rentalCostDisplay')"
                />
              </div>
            </div>

          </div>

          <button type="submit">Agregar al Inventario</button>
        </form>
      </div>
    </div>
  </div>
</template>

  <script>
import axios from "axios";
import baseUrl from "../api";
  import { mapState } from 'vuex';
  
  import Swal from 'sweetalert2';

  export default {
  name: "AltaDeInventario",
  components: {
  },
  computed: {
    ...mapState(['id_usuario']),  // Mapea directamente el id_usuario desde Vuex
  },
  data() {
    return {
      productName: "",
      brand: "",
      description: "",
      color: "",
      size: "",
      sizeNumber: "", // Almacena el número de talla seleccionado
      purchaseCost: 0,
      rentalCost: 0,
      dressPhoto: null,
      previewImage: null,
      purchaseCostDisplay: "0.00", // Para mostrar el valor con formato
      rentalCostDisplay: "0.00",   // Para mostrar el valor con formato
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.dressPhoto = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    }, formatCurrency(field) {
      let value = this[field].replace(/\D/g, ''); // Solo números
      if (value) {
        value = parseFloat(value) / 100;  // Agregar ".00"
        this[field] = `$${value.toFixed(2)}`; // Formato con el signo $ y dos decimales
      }
    },
    clearDefaultValue(field) {
      if (this[field] === '0.00') {
        this[field] = '';
      }
    },
    restoreDefaultValue(field) {
      if (this[field] === '') {
        this[field] = '0.00';
      }
    },
    async submitForm() {
  // Convierte y valida los valores numéricos
  const parsedPurchaseCost = parseInt(this.purchaseCost, 10);
  const parsedRentalCost = parseFloat(this.rentalCost);
  const parsedSizeNumber = parseFloat(this.sizeNumber);
// Validar que la imagen esté adjunta
if (!this.dressPhoto) {
    Swal.fire({
      icon: 'warning',
      title: 'Falta la foto',
      text: 'Por favor, adjunta una foto del vestido.',
    });
    return; // Detiene el envío si no se ha adjuntado una imagen
  }


  if (isNaN(parsedPurchaseCost) || isNaN(parsedRentalCost) || isNaN(parsedSizeNumber)) {
    alert("Por favor, asegúrate de que los valores de Costo de Compra, Costo de Renta y Número de Talla sean válidos.");
    return; // Detiene el envío si alguno no es válido
  }

  // Crea el FormData
  const formData = new FormData();
  formData.append("model", this.productName);
  formData.append("brand", this.brand);
  formData.append("description", this.description);
  formData.append("color", this.color);
  formData.append("size", this.size);
  formData.append("sizeNumber", parsedSizeNumber);
  formData.append("purchaseCost", parseFloat(this.purchaseCostDisplay.replace('$', '').replace(',', '').trim()));
        formData.append("rentalCost", parseFloat(this.rentalCostDisplay.replace('$', '').replace(',', '').trim()));

  formData.append("dressPhoto", this.dressPhoto);
  formData.append("id_usuario", this.id_usuario);

  // Verifica los datos antes de enviarlos
  formData.forEach((value, key) => {
    console.log(key, value);
  });

  try {
    const url = `${baseUrl}/api/inventory`; // Construye la URL completa
    const response = await axios.post(url, formData);
    console.log("Respuesta del servidor:", response);
    Swal.fire({
          icon: 'success',
          title: '¡Producto agregado exitosamente!',
        });    this.resetForm();
  } catch (error) {
    console.error("Hubo un error al agregar el producto:", error);
    Swal.fire({
          icon: 'error',
          title: 'Hubo un error',
          text: 'Ocurrió un error al agregar el producto',
        });  }
},
    resetForm() {
      this.productName = "";
      this.brand = "";
      this.description = "";
      this.color = "";
      this.size = "";
      this.sizeNumber = "";
      this.purchaseCost = 0;
  this.rentalCost = 0;
  this.dressPhoto = null; // Resetea el archivo de imagen
  this.previewImage = null; // Resetea la vista previa de la imagen
  this.purchaseCostDisplay = "0.00"; // Resetea el valor de costo de compra
  this.rentalCostDisplay = "0.00"; // Resetea el valor de costo de renta
   // Limpiar el campo de archivo para que no quede con el nombre de la foto anterior
   const inputFile = document.getElementById('dressPhoto');
  if (inputFile) {
    inputFile.value = '';  // Resetea el valor del campo de archivo
  }
    },
  },
};
  </script>
  
  <style scoped>
  /* Estilos generales */
 /* Contenedor principal */
 .alta-inventario {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: #f4f4f4;
  padding: 40px 20px;
  
  /* Fondo de marca de agua */
  background: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="600" height="150" viewBox="0 0 600 150"%3E%3Ctext x="10" y="50" font-size="50" font-family="Arial, sans-serif" fill="rgba(0, 0, 0, 0.1)" transform="rotate(-30)"%3EMiss Coquette%3C/text%3E%3C/svg%3E') repeat;
  background-size: 200px 200px; /* Ajuste del tamaño para evitar el corte */
}
  .content {
    text-align: center;
    width: 100%;
    max-width: 800px;
  }
  
  h2 {
    font-size: 28px;
    color: #333;
    margin-bottom: 20px;
  }
  
  p {
    font-size: 16px;
    color: #666;
  }
  
  /* Card */
  .form-card {
    background-color: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 20px;
    display:flex;

    align-items: center; /* Centra el contenido horizontalmente */
    gap: 0px; /* Espaciado entre grupos */
    position: relative;
    max-width: 700px;
    width: 100%;
    margin: 20px auto;
  }
  /* Grupos de entradas */
.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px; /* Aumenta el espacio entre las filas del formulario */
  margin-bottom: 20px; /* Espaciado adicional entre las filas */
}
/* Grupo de entradas alineado */
.input-group {
  display: flex;
  gap: 20px;
  justify-content: space-between; /* Asegura que las columnas estén distribuidas de manera equitativa */
}

.input-group > div {
  flex: 1; /* Cada campo ocupa el mismo ancho */
  min-width: 150px; /* Un ancho mínimo para cada campo */
}



  /* Fila con dos columnas */
  .align-columns {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .column {
    flex: 1;
    padding: 0 10px;
  }
  
  .image-preview-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* Tarjeta flotante */
.floating-card {
  background-color: white;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.2); /* Sombra flotante */
  border-radius: 12px; /* Bordes redondeados */
  padding: 10px;
  position: relative;
  max-width: 700px;
  margin: 40px auto; /* Espaciado superior/inferior */
  transform: translateY(0); /* Simula "flotación" */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Transiciones suaves */
}

/* Efecto de elevación al pasar el mouse */
.floating-card:hover {
  transform: translateY(-10px); /* Flota ligeramente hacia arriba */
  box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.3); /* Sombra más pronunciada */
}

  .image-preview {
    width: 150px;
    height: 150px;
    border: 2px dashed #ddd;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f9f9f9;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  /* Estilo para el select que mantiene el diseño anterior */
select {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 15px;
  font-size: 16px;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

/* Cuando el select está en foco */
select:focus {
  border-color: #007bff;
  outline: none;
}
  /* Inputs */
  input[type="text"],
  input[type="number"],
  input[type="file"] {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-bottom: 15px;
    font-size: 16px;
    box-sizing: border-box;
  }
  
  /* Botón */
  button {
    width: 100%;
  padding: 11px;
  margin-top: 0px;
  font-size: 1rem;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 600;
  font-family: 'Karla';
  background: linear-gradient(135deg, #c36aa0, #fca2cf);
  color: white;
  box-shadow: 0 4px 15px rgba(0,0,0,0.15);
    transition: background-color 0.3s ease;
  }
  
  button:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
  .form-card {
    padding: 15px;
  }
  .input-group {
    flex-direction: column;
    gap: 10px;
  }
  .column {
    padding: 0;
  }
  .image-preview {
    width: 100px;
    height: 100px;
  }
  .form-card button {
    font-size: 15px;
  }
}
  </style>
  